export default function whenDOMNodeLoaded(cssquery, callback, tries = 1000) {
	const MAXTRIES = tries;
	let tryCount = 0;
	let nodes = document.querySelectorAll(cssquery);

	const intervalId = setInterval(() => {
		if (nodes.length) {
			nodes.forEach(callback);
			clearInterval(intervalId);
			return;
		}

		if (tryCount === MAXTRIES) {
			console.info("Could not query NODE element from DOM");
			clearInterval(intervalId);
			return;
		}

		nodes = document.querySelectorAll(cssquery);
		tryCount += 1;
	}, 50);
}